const api = `/api`;
export const TaskApi = `${api}/task.json`;
export const BookmarkApi = `${api}/bookmark.json`;
export const ChartistApi = `${api}/chartistData.json`;
export const ChartjsApi = `${api}/chartjsData.json`;
export const ChatMemberApi = `${api}/chatMember.json`;
export const ChatApi = `${api}/chat.chats.json`;
export const ContactApi = `${api}/contacts.json`;
export const ProductsApi = `${api}/product.json`;
export const EmailApi = `${api}/email.json`;
export const ImageLightApi = `${api}/image-light.json`;
export const BigImageApi = `${api}/image-big-light.json`;
export const MasonryApi = `${api}/masonry.json`;
export const GooglechartApi = `${api}/googleChartData.json`;
export const AllProjectApi = `${api}/allProject.json`;
export const SearchAllTabsApi = `${api}/searchAllTabs.json`;
export const TableDataApi = `${api}/tableData.json`;
export const TodoApi = `${api}/todo.json`;
export const JobSearchApi = `${api}/jobSearch.json`;
export const LearningApi = `${api}/learning.json`;
export const KnowledgebaseApi = `${api}/knowledgebaseDB.json`;
export const FaqApi = `${api}/Faq.json`;
export const UserCardApi = `${api}/usercard.json`;
export const StickyApi = `${api}/sticky.json`;
export const TypeaheadDataApi = `${api}/typeaheadData.json`;
export const FeatherDataApi = `${api}/featherData.json`;
export const FlagIconDataApi = `${api}/flagIconData.json`;
export const FontawsomeDataApi = `${api}/fontawsomeData.json`;
export const IcoDataApi = `${api}/icoData.json`;
export const ThemifyDataApi = `${api}/themifyData.json`;

export const ProjectApi = `apiV1/project/`;
export const ProjectPaginatedApi = `apiV1/project-paginated/`;
export const CashFlowApi = window.location.origin.includes(
  "https://mysite.materialdepot.in"
)
  ? "https://api-prod-mysite-new.materialdepot.in/apiV1/cash-flow/"
  : "https://api-prod-mysite-new.materialdepot.in/apiV1/cash-flow/";

export const VendorApi = `apiV1/vendor/`;
export const PaginatedVendorApi = `apiV1/vendor-paginated/`;
export const OrganisationProfileAPI = `apiV1/organisation-profile/`;
export const PoRevisionAPI = "apiV1/po-revision/";
export const TermsAndCondtitionsAPI = `apiV1/terms-and-condition/`;
export const OrganisationFlows = `apiV1/organisation-approval-flow/`;
export const GSTAPI = `apiV1/gst/`;
export const TaxOptionAPI = `apiV1/tax-option/`;
export const OrganisationUsers = `apiV1/user-organisation/`;
export const OrganisationcategoryApi = `apiV1/organisation-item-category/`;
export const OrganisationFlowMembers = `apiV1/organisation-approval-flow-members/`;
export const BudgetApi = "apiV1/item/";
export const SubItemApi = "apiV1/sub-item/";
export const PoWoApi = "apiV1/po/";
export const PowoPdfApi = "apiV1/po-pdf/";
export const ResendPoMailApi = "apiV1/resend-po-mail/";
export const RecreateApprovalFlow = "apiV1/re-create-approval-flow/";
export const PowoPdfOpenApi = window.location.origin.includes(
  "https://mysite.materialdepot.in"
)
  ? "https://api-prod-mysite-new.materialdepot.in/apiV1/po-pdf/"
  : "https://api-prod-mysite-new.materialdepot.in/apiV1/po-pdf/";
export const EstimatePdfOpenApi = window.location.origin.includes(
  "https://mysite.materialdepot.in"
)
  ? "https://api-prod-mysite-new.materialdepot.in/apiV1/estimate-pdf/"
  : "https://api-prod-mysite-new.materialdepot.in/apiV1/estimate-pdf/";
export const PowoDeliveryChallanOpenApi = window.location.origin.includes(
  "https://mysite.materialdepot.in"
)
  ? "https://api-prod-mysite-new.materialdepot.in/apiV1/po-delivery-challan/"
  : "https://api-prod-mysite-new.materialdepot.in/apiV1/po-delivery-challan/";

export const ProjectMemberApi = "apiV1/project-member/";
export const ProjectAddressApi = "apiV1/address/";
export const PoApi = "apiV1/po/";
export const EstimateApi = "apiV1/estimate/";
export const EstimateRevisionDataApi = "apiV1/estimate-revision/";
export const EstimateResendEmail = "apiV1/resend-estimate-mail/";
export const EstimateDuplicateApi = "apiV1/estimate-duplicate/";
export const EstimateListApi = "apiV1/project-estimate-list/";
export const EstimateCreateBudgetItems = "apiV1/estimate-item-budget/";
export const EstimateExcelApi = "apiV1/estimate-excel/";
export const PoItemApi = "apiV1/po-item/";
export const PoTermsApi = "apiV1/po-payment-term/";
export const PoDocumentsApi = "apiV1/po-documents/";
export const PoApprovalsApi = "apiV1/approval/";
export const CurrencyApi = "apiV1/currency/";
export const OrganisationBranchApi = "apiV1/orgainsation-branch/";
export const BulkUploadItemApi = "apiV1/bulk-item/";
export const BulkUploadSubItemApi = "apiV1/bulk-sub-item/";
export const BulkUploadVendorApi = "apiV1/bulk-vendor/";
export const PoAdditionalChargesApi = "apiV1/po-additional-charges/";
export const ConfigApprovalFlowApi = "apiV1/config-approval-flow/";
export const ProjectFlowMembersApi = "apiV1/project-approval-flow-member/";
export const ProjectFileApi = `apiV1/project-files/`;
export const ProjectFileVerify = `apiV1/verify-file-version/`;
export const contactForm = "apiV1/vendor-request/";
export const TodoDashboardApi = "apiV1/to-do-dashboard/";

export const ProductOpenSearchApi =
  "https://apiv2.materialdepot.in/apiV1/product-search-v2/";
export const loginOtp = "apiV1/login-otp/";
export const verifyOtp = "apiV1/verify-otp/";
export const dashboardGraphApi = "apiV1/dashboard/";
export const UserDetailsApi = "apiV1/current-user/";
export const ItemsDeleteApi = "apiV1/item-delete/";
export const PoRaisedItemApi = "apiV1/po-raised-item/";
export const BidListApi = "apiV1/bid/";
export const BidComaprisonApi = "apiV1/bid-compare/";
export const RequestBidRevision = "apiV1/bid-revision/";
export const UserPermission = "apiV1/user-permission/";

export const ClientApi = "apiV1/client/";

export const PoBudgetDownloadApi = "apiV1/budget-download/";
export const ProductExploreApi = "mdV1/product-search/";
export const RateContractApi = "apiV1/rate-contract/";
export const AddBudgetItemFromRateContractApi = "apiV1/rate-contract-to-item/";
export const AddBudgetItemFromMasterRateContractApi =
  "apiV1/master-rate-contract-to-item/";
export const RateContractInfoApi = "apiV1/rate-contract-info/";
export const GetLastProjectOfBranch = "apiV1/get-last-project/";
export const PostalApiUrl = "https://api.postalpincode.in/pincode/";
export const RateContractInfoMasterApi = "apiV1/master-rate-contract-info2/";
export const RateContractVariantHandleApi = "apiV1/get-md-product-details/";
export const RateBulkUploadContractApi = "apiV1/bulk-rate-contract/";

export const ProjectWishlistApi = "apiV1/get-wishlist-product/";
export const RateContractMasterCategoryApi = "apiV1/master-categeory/";
export const RateContractMasterBrandApi = "apiV1/master-brand/";
export const AddProjectWishlistApi = "apiV1/product-wishlist/";
export const RemoveProjectWishlistApi = "apiV1/product-wishlist/";

export const GoogleAuthLinkApi = "apiV1/google-register";
export const GoogleAuthCodeApi = "apiV1/callback";

export const OrganisationProductApi = "apiV1/organisation-product/";

export const ProductDetailsApi =
  "https://apiv2.materialdepot.in/apiV1/product-details-2";

export const ProductAutoCompleteApi =
  "https://apiv2.materialdepot.in/apiV1/auto-complete/";

export const InventoryCategoryApi = "apiV1/inventory-category/";
export const InventorySubCategoryApi = "apiV1/inventory-sub-category/";
export const InventoryItemApi = "apiV1/inventory-item/";
export const InventoryCustomerApi = "apiV1/customer/";

export const MDCategoryApi = "https://apiv2.materialdepot.in/apiV1/category/";

export const VendorCataloguesApi = "apiV1/vendor-catalogues/";
